<div class="dashboard-section-header">
  <h2 *ngIf="title">{{title}}</h2>
  <app-search-filters [(ngModel)]="searchOptions" class="ms-auto"></app-search-filters>
</div>

<!-- begin::Table container -->
<div class="table-responsive p-relative" *ngIf="($donations | async) && ($donations | async)?.length">
  <!-- begin::Table -->

  <div class="loading-container" *ngIf="$loading | async">
    <div class="p-relative w-100">
      <nz-spin nzTip="Loading..."></nz-spin>
    </div>
  </div>

  <table
    class="table align-middle gs-0 gy-4 donation-table"
  >

    <thead>
      <tr>
        <th class="dicon"></th>
        <th style="width:200px;">Transaction ID</th>
        <th>Donor</th>
        <th>Status</th>
        <th>Tax Credit</th>
        <th>Date</th>
        <th>Amount / Net</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let donation of $donations | async">
        <td class="dicon">
          <div class="donation-icon-container">
            <i class="qricon-subscription-model" *ngIf="donation.stripe_subscription_id"></i>
            <i class="qricon-zakat" *ngIf="!donation.stripe_subscription_id"></i>
          </div>
        </td>
        <td>
          <p class="field-primary">ID: {{donation.id | slice: 0: 8}}...</p>
          <p class="field-secondary"><app-copy-button [content]="donation.id" [label]="'Full ID'"></app-copy-button></p>
        </td>
        <td>
          <ng-container *ngIf="donation.donor">
            <div class="d-flex align-items-center">
              <div class="donor-icon">
                <i class="menuicon-success-1"></i>
              </div>
              <div class="text">
                <p class="field-primary" *ngIf="donation.donor.first_name">{{donation.donor.first_name}} {{donation.donor.last_name}}</p>
                <p class="field-primary" *ngIf="!donation.donor.first_name">{{donation.donor.email}}</p>
                <a class="field-secondary" [routerLink]="'/donors/' + donation.donor_id" target="_blank">View Donor</a>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!donation.donor">
            <div class="d-flex align-items-center">
              <div class="donor-icon negative">
                <i class="qricon-unknown"></i>
              </div>
              <p class="field-primary negative">Anonymous</p>
            </div>
          </ng-container>
        </td>
        <td>
          <ng-container *ngIf="donation.status === 'complete'">
            <div class="d-flex align-items-center">
              <div class="donor-icon success">
                <i class="fi fi-br-check"></i>
              </div>
              <p class="field-primary success">Complete</p>
            </div>
          </ng-container>
          <ng-container *ngIf="donation.status === 'active'">
            <div class="d-flex align-items-center">
              <div class="donor-icon success">
                <i class="fi fi-br-check"></i>
              </div>
              <p class="field-primary success">Active</p>
            </div>
          </ng-container>
          <ng-container *ngIf="donation.status === 'draft'">
            <div class="d-flex align-items-center">
              <div class="donor-icon negative">
                <i class="fi fi-br-cross"></i>
              </div>
              <p class="field-primary negative">Incomplete</p>
            </div>
          </ng-container>
          <ng-container *ngIf="donation.status === 'refunded'">
            <div class="d-flex align-items-center">
              <div class="donor-icon danger">
                <i class="fi fi-br-shield-exclamation"></i>
              </div>
              <p class="field-primary danger">Refunded</p>
            </div>
          </ng-container>
          <ng-container *ngIf="donation.status === 'cancelled'">
            <div class="d-flex align-items-center">
              <div class="donor-icon danger">
                <i class="fi fi-br-shield-exclamation"></i>
              </div>
              <p class="field-primary danger">Cancelled</p>
            </div>
          </ng-container>
        </td>
        <td>
          <p class="field-primary" *ngIf="donation.donor && donation.donor?.first_name">Yes</p>
          <p class="field-primary" *ngIf="!donation.donor || !donation.donor?.first_name">No</p>
          <p class="field-secondary">Gift Aid</p>

        </td>
        <td>
          <p class="field-primary">{{donation.created_at | date: 'mediumDate'}}</p>
          <p class="field-secondary">{{donation.created_at | date: 'hh:mm:ss a'}}</p>
        </td>
        <td>
        <ng-container [ngTemplateOutlet]="paymentTemplate"
                      [ngTemplateOutletContext]="{payment: hasNetPayment(donation)}">
        </ng-container>
        </td>
      </tr>
    </tbody>

  </table>

</div>

<div class="empty-state" *ngIf="!($loading | async) && ($donations | async) && !($donations | async)?.length">

  <h2>No Donations Found</h2>
  <p>Either there are no donations at all, or you need to adjust the filters.</p>

</div>

<div class="pagination-container mt-8 text-right" *ngIf="totalPages | async">
  <nz-pagination (nzPageIndexChange)="page = $event" [nzPageSize]="20" [nzPageIndex]="page" [nzTotal]="totalPages | async"></nz-pagination>
</div>

<ng-template
  #paymentTemplate
  let-payment="payment"
>
  <ng-container *ngIf="payment">
    <p class="field-primary">{{payment.amount / 100 | currency: payment.currency}}</p>
    <p class="field-secondary">{{payment.net / 100 | currency: payment.currency}}</p>
  </ng-container>
  <ng-container *ngIf="!payment">
    <p class="field-primary">--</p>
    <p class="field-secondary">--</p>
  </ng-container>

</ng-template>
